import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AboutusService } from 'src/services/aboutus.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { Carousel } from 'primeng/carousel';
import { forkJoin } from 'rxjs';
import { Observable, of, throwError } from 'rxjs';

@Component({
  selector: 'app-about-us-items',
  templateUrl: './about-us-items.component.html',
  styleUrls: ['./about-us-items.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class AboutUsItemsComponent implements OnInit {
  public title: string;
  public aboutUsDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  public imagesList: any;
  public responsiveOptions: any;
  public cultureDetails: any = [];
  public climateDetails: any = [];
  public geographyDetails: any = [];
  public historyDetails: any = [];
  public societyDetails: any = [];
  public aboutUsDetailsList: any;
  public cultureDetailsList: any;
  public societyDetailsList: any;
  public carousel: boolean;
  public artDetails: any = [];
  public sociatyDetails: any = [];
  public culture: boolean = false;
  public society: boolean = false;
  public aboutRefList: any = [];
  public culRefList: any = [];
  public socityRefList: any = [];
  activeIndex: any;
  displayCustom: boolean;
  images: any = [];
  // #enddocregion property declaration

  /**
   * constructor
   * @param route
   * @param router
   * @param aboutusService
   * @param messageService
   * @param confirmationService
   */
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public aboutusService: AboutusService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    //The touchmove event is fired when the user moves the finger across the screen.
    Carousel.prototype.onTouchMove = () => {};
    //Bind Responsive Options for Carousel with no of visibile images,scroll with respecive to size of device
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    //ngOnInit method
    //fetching query parameters
    this.route.queryParams.subscribe((list) => {
      this.title = list['selectedPage'];
      if (this.title == 'culture' || this.title == 'Culture') {
        this.getAboutUsDetails(this.title);
        this.society = false;
        this.culture = true;
        this.getCulture();
      } else if (this.title == 'society' || this.title == 'Society') {
        this.culture = false;
        this.society = true;
        this.getAboutUsDetails(this.title);
        this.getSociety();
      }
    });
  }

  /**
   * getAboutUsDetails
   * get details of selected page
   * @param selectedValue
   */
  async getAboutUsDetails(selectedValue: any) {
    this.aboutusService.getAboutUsDetails(selectedValue).subscribe(
      (data) => {
        this.aboutUsDetails = data;
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  /**
   * get details-page while clicking on the image in the caurosel and redirecting to respeced pages according to data
   * @param selectedValue
   */
  async getDetails(selectedValue: any) {
    if (selectedValue == 'culture' || selectedValue == 'Culture') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/about-us-items'], {
          queryParams: { selectedPage: selectedValue },
        })
      );
    } else if (selectedValue == 'Society' || selectedValue == 'society') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/about-us-items'], {
          queryParams: { selectedPage: selectedValue },
        })
      );
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/about-us-detail'], {
          queryParams: { selectedPage: selectedValue },
        })
      );
    }
  }

  /**
   * get culture details
   */
  getCulture() {
    let cuisinesRecepies = this.aboutusService.getCuisinesRecepiesDetails();
    let cultureArchitecture = this.aboutusService.getCultureArchitectureDetails();
    let cultureArt = this.aboutusService.getCultureArtDetails();
    forkJoin([cuisinesRecepies, cultureArchitecture, cultureArt]).subscribe(
      (results) => {
        if (results.length > 0) {
          this.cultureDetailsList = results;
        }
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }
  /**
   * get Society Details
   */
  getSociety() {
    this.aboutusService.getAllCultureDetails().subscribe((results) => {
      if (results.length > 0) {
        this.societyDetailsList = results;
      }
    });
  }
  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
  //   let peopleDetails = this.aboutusService.getPeopleDetails();
  //   let cultureReligionDetails = this.aboutusService.getCultureReligionDetails();
  //   let languageDetails = this.aboutusService.getLanguageDetails();
  //  return forkJoin([peopleDetails, cultureReligionDetails, languageDetails]);
  //  .subscribe(
  //     (results) => {
  //       if(results.length>0){
  //       this.societyDetailsList = results;
  //       }
  //     },
  //     (err) => {
  //       this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
  //     }
  // );
  //  }
}
